<template>
    <section
        class="trip-element"
        :class="{
            'trip-element--flag-dk': trip.language ? trip.language.short === 'DK' : false,
            'trip-element--flag-uk': trip.language ? trip.language.short === 'EN' : false,
            'trip-element--flag-de': trip.language ? trip.language.short === 'DE' : false,
            'trip-element--is-b2b': trip.trip_type === 0,
        }"
        v-if="trip"
    >
        <div class="b2b-label">
            B2B
        </div>
        <div>
            <span class="large-time">{{ trip.processed.begin }}</span>
            - {{ trip.processed.end }}
        </div>
        <div>
            <span class="large-spots">{{ availableTickets }}</span>
            {{ lang.tickets.list.spots_left }}
        </div>
        <div class="basket-form">
            <div class="form-inline">
                <input
                    v-model.number="amount"
                    type="text"
                    class="ticket-amount text-center form-inline form-control"
                    :class="{'error': availableTickets < amount}"
                >
                <button
                    class="btn btn-small add-to-cart"
                    :disabled="availableTickets < amount || successMsg !== ''"
                    @click="emitAdd"
                >
                    <span class="glyphicon glyphicon-shopping-cart"></span>
                    <span v-html="successMsg || lang.main.add_to_cart"></span>
                </button>
            </div>
        </div>
    </section>
</template>

<script>

export default {
    props: {
        lang: Object,
        trip: Object,
    },

    data() {
        return {
            successMsg: '',
            amount: 1,
            available: null,
        }
    },

    computed: {
        availableTickets() {
            if (this.available === null) {
                return this.trip.trip_size - this.trip.processed.sold
            }
            return this.available
        }
    },

    methods: {
        emitAdd() {
            new Promise((resolve, reject) => {
                this.$emit('addToCart', {
                    amount: this.amount,
                    tripId: this.trip.id,
                    resolve: resolve,
                    reject: reject,
                })
            }).then((response) => {
                if (response.success) {
                    this.successMsg = '<span class="glyphicon glyphicon-ok"></span>'
                    this.amount = 1
                    setTimeout(() => {
                        this.successMsg = ''
                    }, 3000)
                }
                this.available = response.available
            }).catch((error) => {
                console.error(error)
            })
        }
    },
}
</script>

<style lang="scss" scoped>
@import "#/base";

.add-to-cart {
    width: 101px;
}
.trip-element {
    position: relative;
    display: flex;
    width: 100%;
    box-shadow: inset 0 -4px 0 rgba(0, 0, 0, 0.09);
    border-radius: 5px;
    font-size: 2rem;
    color: rgb(75, 75, 75);
    flex-direction: column;
    padding: 10px 20px;
    margin-bottom: 10px;
    background: #fff no-repeat;

    &--flag-dk {
        background-image: url('/img/shop/dk.png');

        @include desktop {
            background-image: url('/img/shop/dk_desktop.png');
        }
    }

    &--flag-uk {
        background-image: url('/img/shop/uk.png');

        @include desktop {
            background-image: url('/img/shop/uk_desktop.png');
        }
    }

    &--flag-de {
        background-image: url('/img/shop/de.png');

        @include desktop {
            background-image: url('/img/shop/de_desktop.png');
        }
    }

    .b2b-label {
        display: none;
        position: absolute;
        right: 200px;
        top: inherit;
        bottom: 21px;
        color: white;
        background-color: rgba(232,99,77,1);
        border-radius: 5px;
        font-weight: bold;
        padding: 0 5px;

        @include desktop {
            right: 220px;
            top: 28px;
            bottom: inherit;
        }
    }

    &--is-b2b {
        .b2b-label {
            display: block;
        }
    }

    @include desktop {
        font-size: 2rem;
        padding: 18px 40px;
        margin-bottom: 15px;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }

    .large-time {
        color: rgb(36, 36, 36);
        font-size: 5rem;
        margin-right: 5px;

        @include desktop {
            font-size: 3.5rem;
            margin-right: 5px;
        }
    }

    .large-spots {
        color: rgb(36, 36, 36);
        font-size: 3rem;
        margin-right: 5px;


        @include desktop {
            font-size: 3.5rem;
            margin-right: 5px;
        }
    }

    .basket-form {
        justify-content: flex-end;
    }

    div {
        display: flex;
        align-items: baseline;
    }
    input {
        width:60px;
        margin-right: 10px;
        height: 30px;
        margin-top: 8px;

        .error {
            border: 2px solid red;
        }
    }
}
</style>
